var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5263 15.082C11.8209 15.3223 12.2556 15.3049 12.5302 15.0303L17.5302 10.0303C17.8231 9.73738 17.8231 9.26262 17.5302 8.96973C17.2373 8.67684 16.7626 8.67684 16.4697 8.96973L11.9999 13.4395L7.53022 8.96973C7.23732 8.67684 6.76256 8.67684 6.46967 8.96973C6.17678 9.26262 6.17678 9.73738 6.46967 10.0303L11.4697 15.0303L11.5263 15.082Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/select-arrow.c9ac207637d30885637cbbc471518057.svg";
export { ForwardRef as ReactComponent };